import React from 'react';
import { useQuery } from 'react-query';
import { Box, Typography, Grid, Card, CardContent, Chip, Rating, useTheme, useMediaQuery } from '@mui/material';
import { maintenanceStaffAPI } from '../services/api';

const safeArray = (val) => Array.isArray(val) ? val : [];

const MaintenanceStaff = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { data: staff = [], isLoading } = useQuery('maintenance-staff', maintenanceStaffAPI.getAll);

  if (isLoading) return <Typography>Loading...</Typography>;

  const staffSafe = safeArray(staff);

  return (
    <Box sx={{ p: isMobile ? 1 : 2 }}>
      <Typography variant={isMobile ? "h5" : "h4"} gutterBottom sx={{ mb: isMobile ? 2 : 3 }}>
        Maintenance Staff Management
      </Typography>
      <Grid container spacing={isMobile ? 2 : 3}>
        {staffSafe.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member.staffId}>
            <Card sx={{ 
              height: '100%',
              minHeight: isMobile ? 'auto' : 200,
              boxShadow: isMobile ? 1 : 2
            }}>
              <CardContent sx={{ p: isMobile ? 2 : 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                  <Typography variant={isMobile ? "body1" : "h6"} sx={{ fontWeight: 'bold' }}>
                    Staff #{member.staffId}
                  </Typography>
                  <Chip 
                    label={member.isAvailable ? 'Available' : 'Busy'} 
                    color={member.isAvailable ? 'success' : 'warning'}
                    size="small"
                  />
                </Box>
                
                <Box sx={{ mb: 2 }}>
                  <Typography 
                    color="textSecondary" 
                    variant={isMobile ? "caption" : "body2"}
                    sx={{ mb: 0.5 }}
                  >
                    User ID:
                  </Typography>
                  <Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 'medium' }}>
                    {member.userId}
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 2 }}>
                  <Typography 
                    color="textSecondary" 
                    variant={isMobile ? "caption" : "body2"}
                    sx={{ mb: 0.5 }}
                  >
                    Phone:
                  </Typography>
                  <Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 'medium' }}>
                    {member.phoneNumber}
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 2 }}>
                  <Typography 
                    color="textSecondary" 
                    variant={isMobile ? "caption" : "body2"}
                    sx={{ mb: 0.5 }}
                  >
                    Specialization:
                  </Typography>
                  <Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 'medium' }}>
                    {member.specialization}
                  </Typography>
                </Box>
                
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: isMobile ? 'flex-start' : 'center',
                  gap: isMobile ? 1 : 0
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Rating 
                      value={member.rating || 0} 
                      readOnly 
                      size={isMobile ? "small" : "medium"}
                    />
                    <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                      ({member.totalComplaints || 0} complaints)
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      {staffSafe.length === 0 && (
        <Box sx={{ 
          textAlign: 'center', 
          py: isMobile ? 4 : 6,
          px: 2
        }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No maintenance staff found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Contact administration to add maintenance staff members.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default MaintenanceStaff; 